export default [
  // {
  //   name: 'Trabajadores',
  //   icon: 'mdi-file-excel-outline',
  //   path: '/laboral/workers',
  //   component: () => import(/* webpackChunkName: "workers" */ './views/WorkersPage.vue'),
  //   meta: {
  //     allowedRoles: ['pyme', 'autonomous', 'employees', 'consultant', 'admin', 'superadmin'],
  //     requiresAuth: true,
  //     tooltip: null,
  //     toolbar: false,
  //     drawer: true,
  //   },
  // },
  // {
  //   name: 'Solicitudes Laboral',
  //   icon: 'mdi-file-excel-outline',
  //   path: '/laboral/requests',
  //   component: () =>
  //     import(/* webpackChunkName: "laboral-requests" */ './views/LaboralRequestsPage.vue'),
  //   meta: {
  //     allowedRoles: ['pyme', 'autonomous', 'employees', 'consultant', 'admin', 'superadmin'],
  //     requiresAuth: true,
  //     tooltip: null,
  //     toolbar: false,
  //     drawer: true,
  //   },
  // },
  {
    icon: 'mdi-account-multiple-outline',
    component: () =>
      import(/* webpackChunkName: "mi-personal" */ '@/modules/laboral/views/LaboralPage.vue'),
    name: 'Mi Personal',
    path: '/laboral',
    beforeEnter: (to, from, next) => {
      window.location.href = '/v2/laboral';
    },
    id: 'laboral-toolbar',
    meta: {
      requiresAuth: true,
      allowedRoles: [
        'lopd',
        'pyme',
        'autonomous',
        'employees',
        'consultant',
        'admin',
        'superadmin',
      ],
      toolbar: true,
      badge: true,
      badgeContent: 'newLaboralDocuments',
      badgeChecker: 'userNewLaboralDocuments',
      tooltip: null,
      module: 'laboral',
    },
  },
  {
    // UserPosts will be rendered inside User's <router-view>
    // when /user/:id/posts is matched
    name: 'Información laboral',
    icon: 'mdi-briefcase-outline',
    path: '/dashboard/laboral',
    beforeEnter: (to, from, next) => {
      window.location.href = '/v2/laboral';
    },
    component: () =>
      import(/* webpackChunkName: "dashboard-laboral" */ '@/modules/laboral/views/LaboralPage.vue'),
    meta: {
      allowedRoles: ['pyme', 'autonomous', 'employees', 'consultant', 'admin', 'superadmin'],
      drawer: true,
      tooltip: null,
    },
  },
  // {
  //   name: 'Trabajadores',
  //   icon: 'mdi-account-group',
  //   path: '/dashboard/laboral-workers',
  //   component: () =>
  //     import(/* webpackChunkName: "workers" */ '@/modules/laboral/views/WorkersPage.vue'),
  //   meta: {
  //     allowedRoles: ['pyme', 'autonomous', 'employees', 'consultant', 'admin', 'superadmin'],
  //     requiresAuth: true,
  //     tooltip: null,
  //     toolbar: false,
  //     drawer: true,
  //   },
  // },
  // {
  //   name: 'Solicitudes Laboral',
  //   icon: 'mdi-briefcase',
  //   path: '/dashboard/laboral-requests',
  //   component: () =>
  //     import(/* webpackChunkName: "laboral-requests" */ '@/modules/laboral/views/LaboralRequestsPage.vue'),
  //   meta: {
  //     allowedRoles: ['pyme', 'autonomous', 'employees', 'consultant', 'admin', 'superadmin'],
  //     requiresAuth: true,
  //     tooltip: null,
  //     toolbar: false,
  //     drawer: true,
  //   },
  // },
];
